import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "FilterWrapper";
var classes = {
    summary: "".concat(PREFIX, "-summary"),
    details: "".concat(PREFIX, "-details")
};
var StyledFilterWrapper = styled(Accordion)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: "transparent",
            borderBottom: "1px solid ".concat(theme.palette.divider),
            "&:last-child": {
                borderBottom: 0
            },
            "&::before": {
                display: "none"
            }
        },
        _b["& .".concat(classes.summary)] = {
            ".MuiAccordionSummary-content": {
                margin: 0
            },
            ".MuiAccordionSummary-content.Mui-expanded": {
                margin: 0
            }
        },
        _b["& .".concat(classes.details)] = {
            paddingTop: 0
        },
        _b);
});

export { classes, StyledFilterWrapper as default };
//# sourceMappingURL=index.styled.js.map
